import axios from "axios";

const postContact = async (context, data) => {
    await context.commit('setNotification', null)
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/support/v1/create/contact/`, data)).data
    if (response.success) {
        await context.commit('setNotification', response.code)
    }
};

export default {
    postContact
}